import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { buildMessageTemplate } from "app/main/helpers/message.helper";
import { clone } from "lodash";
import { SanitizeHTMLPipe } from "../../pipes/sanitize-html.pipe";

export enum TemplateHeaderType {
  NONE = "NONE",
  TEXT = "TEXT",
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
  DOCUMENT = "DOCUMENT",
  LOCATION = "LOCATION",
}

export enum TemplateStatus {
  APPROVED = "APPROVED",
  PENDING = "PENDING",
  PAUSED = "PAUSED",
  REJECTED = "REJECTED",
}

export enum TemplateCategory {
  MARKETING = "MARKETING",
  UTILITY = "UTILITY",
  AUTHENTICATION = "AUTHENTICATION",
}

export interface TemplateI {
  service_id?: string;
  name: string;
  header?: string;
  body: string;
  footer?: string;
  buttons: any;
  language: string;
  header_type: TemplateHeaderType;
  header_params: number;
  header_example_params?: any;
  body_params: number;
  body_example_params?: any;
  status?: TemplateStatus;
  category: TemplateCategory;
  channel_id?: number;
}

type TemplateDetails = {
  template: TemplateI;
  params: string[];
};

@Component({
  selector: "app-template-view",
  templateUrl: "./template-view.component.html",
  styleUrls: ["./template-view.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplateViewComponent implements OnChanges {
  headerType = TemplateHeaderType;
  template: TemplateI;
  params: string[] = [];
  mediaLink;
  parameterizedComponents: any = {
    header: null,
    body: null,
  };

  constructor(private sanitizer: DomSanitizer) {}

  @Input()
  set templateDetails(details: TemplateDetails) {
    this.template = details?.template;
    this.params = details?.params;
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("Changes:", changes);
    if (changes.templateDetails.currentValue) {
      this.splitParamsComponent();
    }
  }

  splitParamsComponent = () => {
    const paramsList = clone(this.params);

    // const { body } = this.template;
    if (this.template) {
      console.log(this.params);
      if (this.template.header)
        this.parameterizedComponents.header = this.buildHeader(paramsList);
      if (this.template.body)
        this.parameterizedComponents.body = this.buildBody(
          this.template.body,
          paramsList
        );
    }
  };

  buildHeader = (paramsList) => {
    const headerParam = this.template.header_params ? paramsList.shift() : "X";
    console.log(headerParam );
/*     return this.template.header_params === 0
      ? this.template.header
      : this.template.header_type === this.headerType.TEXT
      ? buildMessageTemplate(this.template.header, [headerParam])
      : headerParam; */
    this.mediaLink = headerParam;
    return this.template.header_params === 0
    ? this.template.header
    : this.template.header_type === this.headerType.TEXT
    ? buildMessageTemplate(this.template.header, [headerParam])
    : this.template.header_type === this.headerType.DOCUMENT
    ? 'assets/images/icons/file-icons/file.png'
    : headerParam;
  };

  buildBody = (text: string, params: string[]): SafeHtml =>
    this.sanitizer.bypassSecurityTrustHtml(buildMessageTemplate(text, params));

  isHeaderMultimedia = () => {
    console.log("Validate is multimedia");
    return [
      TemplateHeaderType.IMAGE,
      TemplateHeaderType.VIDEO,
      TemplateHeaderType.DOCUMENT,
    ].includes(this.template.header_type);
  };

  sanitizeHTML(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
